var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsemination(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.3082C6 16.4797 6.67157 15.8082 7.5 15.8082C8.32843 15.8082 9 16.4797 9 17.3082C9 18.1366 8.32843 18.8082 7.5 18.8082C6.67157 18.8082 6 18.1366 6 17.3082Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 19.8082C10.433 19.8082 12 18.2411 12 16.3082C12 15.7559 12.4477 15.3082 13 15.3082C13.5523 15.3082 14 15.7559 14 16.3082C14 19.3457 11.5376 21.8082 8.5 21.8082C5.46243 21.8082 3 19.3457 3 16.3082C3 13.2706 5.46243 10.8082 8.5 10.8082C9.05229 10.8082 9.5 11.2559 9.5 11.8082C9.5 12.3604 9.05229 12.8082 8.5 12.8082C6.567 12.8082 5 14.3752 5 16.3082C5 18.2411 6.567 19.8082 8.5 19.8082Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6542 11.1902C14.0447 11.5807 14.0447 12.2139 13.6542 12.6044L10.7071 15.5515C10.3166 15.9421 9.68342 15.9421 9.29289 15.5515C8.90237 15.161 8.90237 14.5278 9.29289 14.1373L12.24 11.1902C12.6305 10.7997 13.2637 10.7997 13.6542 11.1902Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3159 3.16728C17.7064 2.77676 18.3396 2.77676 18.7301 3.16728L21.7071 6.1443C22.0976 6.53482 22.0976 7.16799 21.7071 7.55851C21.3166 7.94904 20.6834 7.94904 20.2929 7.55851L19.4965 6.76214L18.4474 7.81128C18.0568 8.2018 17.4237 8.20179 17.0331 7.81126C16.6426 7.42073 16.6426 6.78757 17.0332 6.39705L18.0823 5.34792L17.3159 4.5815C16.9254 4.19097 16.9254 3.55781 17.3159 3.16728Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3013 5.74735C15.6918 5.35683 16.325 5.35683 16.7155 5.74735L19.0971 8.12897C19.4876 8.51949 19.4876 9.15266 19.0971 9.54318L14.845 13.7953C14.4545 14.1858 13.8213 14.1858 13.4308 13.7953L11.0492 11.4136C10.6587 11.0231 10.6587 10.39 11.0492 9.99943L15.3013 5.74735ZM16.0084 7.86867L13.1705 10.7065L14.1379 11.6739L16.9758 8.83608L16.0084 7.86867Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsemination);
export default __webpack_public_path__ + "static/media/insemination.a3780d3999058fe0c402db9382ec3ca9.svg";
export { ForwardRef as ReactComponent };